import { render, staticRenderFns } from "./dialog_1.vue?vue&type=template&id=6c131ce0&scoped=true"
import script from "./dialog_1.vue?vue&type=script&lang=js"
export * from "./dialog_1.vue?vue&type=script&lang=js"
import style0 from "./dialog_1.vue?vue&type=style&index=0&id=6c131ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c131ce0",
  null
  
)

export default component.exports